<ng-container *ngrxLet="precertDashboardData$ as precertDashboardData">
  <ng-container *ngIf="precertDashboardData.errors; else hasData">
    <div class="tile-head flex-row flex-vertical-center">
      <cigna-icon class="dashboard-icon" type="medical-form"></cigna-icon>
      <h3 class="cg-h3">
        {{ 'dashboard.precerts' | translate }}
      </h3>
    </div>
    <div class="tile-section flew-row empty-state-stlying">
      <div data-test="error-msg" class="cg-error-msg-large">
        <cigna-icon type="exclamation-circle"></cigna-icon>
        <div>
          <div>{{ 'shared.common.serviceError' | translate }}</div>
          <div
            *ngIf="precertDashboardData.errors[0]?.message"
            class="cg-margin-top-md"
          >
            {{ precertDashboardData.errors[0].message }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #hasData>
    <ng-container *ngIf="isFlaggedPrecertToggled; else recentPrecerts">
      <div class="tile-head flex-row flex-vertical-center">
        <cigna-icon class="dashboard-icon" type="medical-form"></cigna-icon>
        <h3 class="cg-h3">
          {{ 'dashboard.precerts' | translate }} |
          {{ 'dashboard.flagged' | translate }}
        </h3>
        <div style="margin-left: auto">
          <button
            cignaButton="link small"
            data-test="recentbutton"
            (click)="toggle()"
          >
            {{ 'dashboard.recent' | translate }}
          </button>
          <span class="toggle-pipe">|</span>
          <span data-test="flaggedheader" class="link-small-selected">
            {{ 'dashboard.flagged' | translate }}
          </span>
        </div>
      </div>

      <cigna-precert-detail-list
        [isEditable]="isEditable"
        [isRestrictedImpersonator]="isRestrictedImpersonator"
        [precerts]="precertDashboardData?.data?.flaggedPrecerts"
        [isLoading]="precertDashboardData?.loading"
        [flaggedKeys]="precertDashboardData?.data.flaggedIds"
        [isFlagTile]="true"
        (flag)="updateFlaggedPrecert($event)"
      >
      </cigna-precert-detail-list>
    </ng-container>

    <ng-template #recentPrecerts>
      <div class="tile-head flex-row flex-vertical-center">
        <cigna-icon class="dashboard-icon" type="medical-form"></cigna-icon>
        <h3 class="cg-h3" data-test="precertHeader">
          {{ 'dashboard.precerts' | translate }} |
          {{ 'dashboard.recent' | translate }}
        </h3>
        <div style="margin-left: auto">
          <span data-test="recentheader" class="link-small-selected">
            {{ 'dashboard.recent' | translate }}
          </span>
          <span class="toggle-pipe">|</span>
          <button
            cignaButton="link small"
            data-test="flagbutton"
            (click)="toggle()"
          >
            {{ 'dashboard.flagged' | translate }}
          </button>
        </div>
      </div>

      <cigna-precert-detail-list
        [isEditable]="isEditable"
        [isRestrictedImpersonator]="isRestrictedImpersonator"
        [precerts]="precertDashboardData?.data?.recentPrecerts"
        [isLoading]="precertDashboardData?.loading"
        [flaggedKeys]="precertDashboardData?.data.flaggedIds"
        [isFlagTile]="false"
        (flag)="updateFlaggedPrecert($event)"
      >
      </cigna-precert-detail-list> </ng-template
  ></ng-template>
</ng-container>
